var React = require('react');

function IconCloseMenu (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},[React.createElement("path",{"d":"M44.9727 3V61H15.9727V3H44.9727Z","stroke":"white","strokeWidth":"6","key":0}),React.createElement("path",{"d":"M25.6727 19.3H-0.0273438V44.8H25.6727V19.3Z","fill":"black","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22.8734 19.3L25.6734 22.1L15.8734 32L25.7734 41.9001L22.9734 44.7001L13.0734 34.8L3.17344 44.7001L0.273438 41.9001L10.1734 32L0.273438 22.1L3.07344 19.3L12.9734 29.2001L22.8734 19.3Z","fill":"white","key":2})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"49","height":"64","fill":"white"})))]);
}

IconCloseMenu.defaultProps = {"width":"49","height":"64","viewBox":"0 0 49 64","fill":"none"};

module.exports = IconCloseMenu;

IconCloseMenu.default = IconCloseMenu;
